"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Amplitude", {
    enumerable: true,
    get: function() {
        return Amplitude;
    }
});
var _loadAmplitude = require("./loadAmplitude");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var Amplitude = function Amplitude(config) {
    "use strict";
    _class_call_check(this, Amplitude);
    _define_property(this, "identify", function(userId, traits) {
        var amplitude = window.amplitude;
        amplitude.setUserId(userId);
        if (traits) {
            var identifyEvent = new amplitude.Identify();
            Object.entries(traits).forEach(function(param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                identifyEvent.set(key, value);
            });
            amplitude.identify(identifyEvent);
        }
    });
    _define_property(this, "group", function(groupId, traits) {
        window.amplitude.setGroup(groupId, traits);
    });
    _define_property(this, "page", function(pageName, traits) {
        window.amplitude.track({
            event_type: '[Amplitude] Page Viewed',
            event_properties: _object_spread({
                page_name: pageName,
                '[Amplitude] Page Domain': window.location.hostname,
                '[Amplitude] Page Location': window.location.href,
                '[Amplitude] Page Path': window.location.pathname,
                '[Amplitude] Page Title': window.document.title,
                '[Amplitude] Page URL': window.location.href
            }, traits)
        });
    });
    _define_property(this, "track", function(eventName) {
        var traits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
        window.amplitude.track(eventName, traits);
    });
    _define_property(this, "reset", function() {
        window.amplitude.reset();
    });
    _define_property(this, "revenue", function(price, quantity, type) {
        var amplitude = window.amplitude;
        var event = new amplitude.Revenue().setPrice(price).setQuantity(quantity).setRevenueType(type);
        amplitude.revenue(event);
    });
    var amplitude = (0, _loadAmplitude.loadAmplitude)();
    var _config_defaultTracking;
    var customConfig = {
        defaultTracking: (_config_defaultTracking = config.defaultTracking) !== null && _config_defaultTracking !== void 0 ? _config_defaultTracking : true
    };
    amplitude.init(config.apiKey, customConfig);
};
